import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`;

const categoryIds = [
    "de6c3b5f-4abf-4c70-afb1-1642953fa2e6", // prod
    "1580f547-d640-4cba-95a7-723a4f859795" // acc
];

export const InterieurEnComfortFilter = ({ condensed }) => {
    const filter = useFilter("opties").find((category) =>
        categoryIds.includes(category.optiecategorieId)
    );
    const count = useCount("zoekopties");
    const [value, , onChange] = useField("zoekoptieIds");

    const options =
        filter?.zoekopties
            ?.map(({ zoekoptieId, naam }) => ({
                id: zoekoptieId,
                displayName: naam,
                aantal: count[zoekoptieId]
            }))
            .filter(({ displayName }) => displayName !== "LPG") || [];

    return (
        <Grid>
            <FilterCheckList
                filterId="filter-interieur"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                columns={condensed ? 1 : 3}
                datalayerKey="zoekoptieId"
                maxSize={condensed ? 5 : 0}
            />
        </Grid>
    );
};
